import { render } from "./NetworkError.vue?vue&type=template&id=1afa97b2&scoped=true"
import script from "./NetworkError.vue?vue&type=script&lang=js"
export * from "./NetworkError.vue?vue&type=script&lang=js"

import "./NetworkError.vue?vue&type=style&index=0&id=1afa97b2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1afa97b2"]])

export default __exports__